export default __webpack_public_path__ + "static/media/cecilia-ame.f0b79001.webp";